export enum WeekSlotScenarioEnum {
  Next = 0,
  Previous = 1,
  PreviouslyChoosen = 2,
  SearchForFirstPossibleTimeSlotIn4Weeks = 3
};
